import React from 'react';
import Waypoint from 'react-waypoint';
import loadable from '@loadable/component';

const CollectionsBucketContainer = loadable(() =>
    import('./CollectionsBucketContainer'),
);

export const LazyLoadedCollectionsBucket = () => {
    const [isVisible, setIsVisible] = React.useState(false);

    return (
        <Waypoint bottomOffset={'-100px'} onEnter={() => setIsVisible(true)}>
            <div
                className={`lazy-collections-bucket ${
                    isVisible ? 'lazy-collections-bucket--visible' : ''
                }`}
            >
                {isVisible ? (
                    <CollectionsBucketContainer />
                ) : (
                    <div style={{ height: '100px' }} />
                )}
            </div>
        </Waypoint>
    );
};
